// A deliberately small formatting vocabulary. React escapes all record text;
// model output is never interpreted as HTML or executable links.
function inlineText(text) {
  return text.split(/(\*\*[^*]+\*\*|\*[^*\n]+\*|`[^`]+`)/g).map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={index}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("*") && part.endsWith("*")) return <em key={index}>{part.slice(1, -1)}</em>;
    if (part.startsWith("`") && part.endsWith("`")) return <code key={index}>{part.slice(1, -1)}</code>;
    return part;
  });
}

export default function AssistantMessage({ text = "" }) {
  const blocks = [];
  let paragraph = [];
  let items = [];
  let ordered = false;
  const flushParagraph = () => {
    if (paragraph.length) blocks.push(<p key={blocks.length}>{inlineText(paragraph.join("\n"))}</p>);
    paragraph = [];
  };
  const flushList = () => {
    if (items.length) {
      const List = ordered ? "ol" : "ul";
      blocks.push(<List key={blocks.length}>{items.map((item, index) => <li key={index}>{inlineText(item)}</li>)}</List>);
    }
    items = [];
  };
  for (const line of text.replace(/\r\n?/g, "\n").replace(/\\[ \t]*\n/g, "\n").split("\n")) {
    const bullet = line.match(/^\s*(?:([-*•])|\d+[.)])\s+(.+)$/);
    const heading = line.match(/^#{1,6}\s+(.+)$/);
    if (bullet) {
      flushParagraph();
      const nextOrdered = !bullet[1];
      if (items.length && ordered !== nextOrdered) flushList();
      ordered = nextOrdered;
      items.push(bullet[2]);
    } else {
      flushList();
      if (!line.trim() || heading) {
        flushParagraph();
        if (heading) blocks.push(<p className="ocare-answer-heading" key={blocks.length}>{inlineText(heading[1])}</p>);
      } else paragraph.push(line);
    }
  }
  flushParagraph();
  flushList();
  return <div className="ocare-answer">{blocks}</div>;
}
